const TEXTFIELD = {
  type: "textfield",
  key: "textfield_key",
  label: "Textfield",
  form_display_label: "",
  validate: {
    startWith: "",
    endWith: "",
    minLength: "",
    maxLength: "",
    required: false,
    mandatory: false,
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  text_transform: "",
  default_value: "",
  mass_performance_width: 50,
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const PHONE = {
  type: "phone",
  key: "number_key",
  label: "Phone",
  form_display_label: "",
  validate: {
    mandatory: false,
    custom_js: "",
    required: false,
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  mass_performance_width: 50,
  ai_prompt: "",
  default_country_code: "+91",
  help_text: ""
};

const TEXTAREA = {
  type: "textarea",
  key: "textarea_key",
  label: "Textarea",
  form_display_label: "",
  autoExpand: true,
  validate: {
    minLength: "",
    maxLength: "",
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  text_transform: "",
  default_value: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  mass_performance_width: 50,
  ai_prompt: "",
  help_text: ""
};

const NUMBER = {
  type: "number",
  key: "number_key",
  label: "Number",
  form_display_label: "",
  validate: {
    minValue: "",
    maxValue: "",
    length: "",
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  default_value: 0,
  disable: false,
  mass_performance_width: 50,
  ai_prompt: "",
  // format: ""
  help_text: ""
};

const PASSWORD = {
  type: "password",
  key: "password_key",
  label: "Password",
  form_display_label: "",
  validate: {
    minLength: "",
    maxLength: "",
    required: false,
    passwordPattern: [],
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  mass_performance_width: 50,
  ai_prompt: "",
  help_text: ""
};

const EMAIL = {
  type: "email",
  key: "official_email19",
  label: "Email",
  form_display_label: "",
  validate: {
    endWith: "",
    emailPattern: false,
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  default_value: "",
  on_change: [],
  mass_performance_width: 50,
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const CHECKBOX = {
  type: "checkbox",
  key: "checkbox_key",
  label: "Checkbox",
  form_display_label: "",
  validate: {
    required: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  mass_performance_width: 50,
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const TOGGLE = {
  type: "toggle",
  key: "toggle_key",
  label: "Toggle",
  form_display_label: "",
  mass_performance_width: 50,
  validate: {
    required: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const FILE = {
  type: "file",
  key: "fileUpload",
  label: "File",
  form_display_label: "",
  multiple: true,
  storage: "base64",
  mass_performance_width: 50,
  filePattern: "",
  show_cabinet: false,
  fileMinSize: 0,
  fileMaxSize: 1,
  fileMinRange: 1,
  fileMaxRange: 1,
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  help_text: "",
  upload_on_select: false,
  layout_type: "default",
  acceptable_formats: []
};

const URL = {
  type: "url",
  key: "url_key",
  label: "URL",
  form_display_label: "",
  title: "title",
  mass_performance_width: 50,
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  default_value: "",
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const IMAGE = {
  type: "image",
  key: "image_123",
  label: "Image",
  form_display_label: "",
  fileMinSize: 0,
  fileMaxSize: 1,
  fileMinRange: 1,
  fileMaxRange: 1,
  mass_performance_width: 50,
  multiple: false,
  show_cabinet: false,
  from_camera: false,
  validate: {
    required: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  help_text: "",
  upload_on_select: false,
  layout_type: "default",
  acceptable_formats: []
};

const LOOKUP = {
  key: "lookup_798645",
  type: "lookup",
  label: "Lookup",
  form_display_label: "",
  table_id: "",
  allow_add_entity: false,
  allow_edit_entity: false,
  show_default_option: true,
  mass_performance_width: 50,
  prefill_filtered_data: false,
  exclude_duplicate: false,
  display_fields: [],
  access_fields: [],
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  pre_filters: [],
  prefilters_joined_by: "",
  field_filters: [],
  field_filters_joined_by: "",
  ai_prompt: "",
  help_text: ""
};
const LOOKUP_SM = {
  key: "lookup_768645",
  type: "lookup-sm",
  label: "Lookup SM",
  form_display_label: "",
  table_id: "",
  allow_add_sm: false,
  mass_performance_width: 50,
  exclude_duplicate: false,
  display_fields: [],
  sub_fields: [],
  validate: {
    required: false,
    mandatory: false,
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  show_default_option: true,
  disable: false,
  prefill_filtered_data: false,
  pre_filters: [],
  prefilters_joined_by: "",
  field_filters: [],
  field_filters_joined_by: "",
  ai_prompt: "",
  help_text: ""
};

const OCR = {
  key: "ocr_798645",
  type: "ocr",
  label: "OCR",
  form_display_label: "",
  ai_model: "gemini",
  description: "",
  field_question_mapping: [],
  mass_performance_width: 50,
  validate: {
    required: false,
    mandatory: false,
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  from_camera: false,
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: "",
  layout_type: "default",
  acceptable_formats: []
};
const DocumentOCR = {
  key: "document_ocr_001",
  type: "document-ocr",
  label: "Document-OCR",
  form_display_label: "",

  ai_models: [],
  document_type: "aadhar", // Must be one of: "aadhar", "pan", "bank_passbook", "gst"

  output_mapping: [],

  validate: {
    required: false,
    mandatory: false,
    regex: ""
  },

  from_camera: false,
  on_change: [],
  defaultAction: {
    action: []
  },

  disable: false,
  ai_prompt: "",
  help_text: "",
  layout_type: "default",
  acceptable_formats: []
};

const AI_DOC_ANALYZER = {
  key: "ocr_798645",
  type: "ai-doc-analyzer",
  label: "Image Analyzer",
  form_display_label: "",
  ai_model: "gemini",
  description: "",
  field_question_mapping: [],
  mass_performance_width: 50,
  validate: {
    required: false,
    mandatory: false,
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  from_camera: false,
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: "",
  layout_type: "default",
  acceptable_formats: []
};
const Linked_LOOKUP_SM = {
  key: "linked_lookup_768645",
  type: "linked-sm-lookup",
  label: "Linked Lookup SM",
  form_display_label: "",
  table_id: "",
  allow_add_sm: false,
  exclude_duplicate: false,
  display_fields: [],
  sub_fields: [],
  validate: {
    required: false,
    mandatory: false,
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  prefill_filtered_data: false,
  mass_performance_width: 50,
  show_default_option: true,
  disable: false,
  pre_filters: [],
  prefilters_joined_by: "",
  ai_prompt: "",
  help_text: ""
};

const LOOKUP_RDBMS = {
  key: "lookup_rdbms_798645",
  type: "lookup-rdbms",
  label: "Lookup Rdbms",
  form_display_label: "",
  lookup_query: "",
  filter_varmap: [],
  data_varmap: [],
  primary_key: ""
};

const MASTERDATA_LOOKUP = {
  key: "masterdata-loopup_798645",
  type: "masterdata-lookup",
  label: "Masterdata Lookup",
  form_display_label: "",
  masterdata_type: "rdbms",
  masterdata_id: "",
  remember_rdbms_table_id: "",
  rdbms_to_form_map: [],
  mass_performance_width: 50,
  search_fields: [],
  display_fields: [],
  access_fields: [],
  field_filters: [],
  selected_display_field: null,
  info_fields: [],
  extension_field: null,
  data_source: {
    type: "table", // "table" | "http-template"
    http_template_id: ""
  },
  validate: {
    required: false,
    mandatory: false,
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  pre_filters: [],
  prefilters_joined_by: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const GLOBAL_DATA = {
  key: "global_data_798645",
  type: "global-data",
  label: "Global Data",
  form_display_label: "",
  card_design: {
    mobile: {},
    desktop: {}
  },
  global_field: {},
  field_filters: [],
  mass_performance_width: 50,
  field_filters_joined_by: "",
  validate: {
    required: false,
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  components: [],
  help_text: ""
};

const APP_USER = {
  type: "app-user",
  key: "app_user_123456",
  label: "App User",
  form_display_label: "",
  prefill_current_user: false,
  prefill_filtered_data: false,
  mass_performance_width: 50,
  show_app_user_team_only: false,
  disable: false,
  show_default_option: true,
  validate: {
    required: false,
    mandatory: false,
    backend_validation: false,
    regex: ""
  },
  app_user_filter: {
    groups: [],
    designations: []
  },
  defaultAction: {
    action: []
  },
  access_fields: [],
  ai_prompt: "",
  help_text: "",
  pre_filters: [],
  prefilters_joined_by: ""
};
// const COMMUNITY_USER = {
//   type: "community-user",
//   key: "community_user_123456",
//   label: "Community User",
//   form_display_label: "",
//   prefill_current_user: false,
//   mass_performance_width: 50,
//   show_app_user_team_only: false,
//   disable: false,
//   show_default_option: true,
//   validate: {
//     required: false,
//     mandatory: false,
//     backend_validation: false,
//     regex: ""
//   },
//   app_user_filter: {
//     groups: [],
//     designations: []
//   },
//   defaultAction: {
//     action: []
//   },
//   access_fields: [],
//   ai_prompt: "",
//   help_text: ""
// };

const CONTAINER = {
  type: "container",
  key: "container_key130",
  validate: {
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  components: [],
  disable: false,
  mass_performance_width: 50,
  ai_prompt: "",
  help_text: ""
};

const GRID = {
  label: "Grid Entity",
  form_display_label: "",
  type: "grid",
  key: "grid_key130",
  is_card_format: false,
  import_cart: "",
  sub_form: "",
  components: [],
  mass_performance_width: 50,
  cart_mapping: [],
  ai_prompt: "",
  validate: {
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  card_design: {
    mobile: {},
    desktop: {}
  },
  master_data: "",
  help_text: ""
};

const RICH_GRID = {
  label: "Rich Grid Entity",
  form_display_label: "",
  type: "rich-grid",
  key: "rich-grid_key130",
  is_card_format: false,
  import_cart: "",
  sub_form: "",
  components: [],
  mass_performance_width: 50,
  cart_mapping: [],
  ai_prompt: "",
  validate: {
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  card_design: {
    mobile: {},
    desktop: {}
  },
  master_data: "",
  help_text: ""
};

const RECORDSET = {
  type: "recordset",
  key: "recordset_key130",
  label: "Recordset",
  form_display_label: "",
  validate: {
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  components: [],
  disable: false,
  mass_performance_width: 50,
  ai_prompt: "",
  help_text: ""
};

const RECORDSET_LIST = {
  type: "recordset-list",
  key: "recordset-list_key130",
  label: "Recordset-List",
  form_display_label: "",
  is_card_format: false,
  mass_performance_width: 50,
  components: [],
  disable: false,
  card_design: {
    mobile: {},
    desktop: {}
  },
  import_cart: "",
  // cart_mapping: [],
  ai_prompt: "",
  validate: {
    custom_js: "",
    help_text: "",
    backend_validation: false,
    regex: ""
  }
};

const BUTTON_GROUP = {
  type: "button-group",
  key: "button-group",
  label: "Button Group",
  form_display_label: "",
  block: true,
  mass_performance_width: 50,
  leftIcon: "fa fa-send",
  disableOnInvalid: false,
  confirmation_box: false,
  action: "custom",
  data: {
    values: [],
    disable: false
  },
  validate: {
    // custom: []
    custom_js: "",
    // backend_validation: false,
    regex: ""
  },
  ai_prompt: "",
  help_text: ""
};

const RADIO = {
  type: "radio",
  key: "radio_key",
  label: "Radio",
  form_display_label: "",
  mass_performance_width: 50,
  defaultValue: "",
  isHorizontal: false,
  data: {
    method: "inline",
    data_key: "",
    values: []
  },
  show_chips_format: false,
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  default_value: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const BUTTON = {
  type: "button",
  key: "button",
  mass_performance_width: 50,
  label: "Button",
  form_display_label: "",
  block: true,
  leftIcon: "fa fa-send",
  disableOnInvalid: false,
  action: "custom",
  validate: {
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  help_text: ""
};

const ID_GEN = {
  key: "id_gen_798645",
  type: "id-gen",
  id_gen_config: {
    prefix: "",
    date_format: "",
    reset_type: "na",
    sequence: true
  },
  mass_performance_width: 50,
  label: "Id Gen",
  form_display_label: "",
  validate: {
    required: false,
    mandatory: false,
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  help_text: ""
};

const LEARNING_TEXT = {
  type: "learning-text",
  key: "learning_text",
  label: "Learning Text",
  form_display_label: "",
  defaultValue: "",
  placeholder: "",
  sort: false,
  mass_performance_width: 50,
  multiple: false,
  search_data_api: false,
  show_default_option: true,
  allow_new: true,
  data: {
    method: "default",
    data_key: "",
    values: []
  },
  validate: {
    required: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  default_value: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const LEARNING_TAGS = {
  type: "learning-tags",
  key: "learning_tags",
  label: "Learning Tags",
  form_display_label: "",
  defaultValue: "",
  placeholder: "",
  sort: false,
  multiple: true,
  mass_performance_width: 50,
  search_data_api: false,
  show_default_option: true,
  data: {
    method: "default",
    data_key: "",
    values: []
  },
  validate: {
    required: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  default_value: "",
  allow_new: true,
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const SELECT = {
  type: "select",
  key: "selectField",
  label: "Select",
  form_display_label: "",
  defaultValue: "",
  placeholder: "Select an option",
  mass_performance_width: 50,
  multiple: false,
  data: {
    method: "inline",
    data_key: "",
    values: []
  },
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  default_value: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const NUMBER_SELECT = {
  type: "number-select",
  key: "selectField",
  label: "Number Select",
  form_display_label: "",
  defaultValue: "",
  placeholder: "Select an option",
  mass_performance_width: 50,
  multiple: false,
  data: {
    method: "inline",
    data_key: "",
    values: []
  },
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  default_value: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const SELECTBOXES = {
  type: "selectboxes",
  key: "selectBoxesField",
  label: "Selectboxes",
  form_display_label: "",
  mass_performance_width: 50,
  inline: true,
  data: {
    method: "inline",
    data_key: "",
    values: []
  },
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  default_value: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: "",
  min_selections: "",
  max_selections: ""
};

const MULTI_SELECT_DROPDOWN = {
  type: "multi-select-dropdown",
  key: "multiSelectDropdown",
  label: "Multi Select Dropdown",
  form_display_label: "",
  mass_performance_width: 50,
  inline: true,
  data: {
    method: "inline",
    data_key: "",
    values: []
  },
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  default_value: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  is_searchable: false,
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const CURRENCY = {
  type: "currency",
  key: "price_key",
  label: "Currency",
  form_display_label: "",
  currency: "INR",
  validate: {
    max_digit: "10",
    decimal_point: "2",
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  mass_performance_width: 50,
  disable: false,
  help_text: ""
};

const DATE = {
  type: "date",
  key: "dob_879825",
  label: "Date",
  form_display_label: "",
  prefill_current: false,
  disable: false,
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  block_past_date: false,
  mass_performance_width: 50,
  block_future_date: false,
  ai_prompt: "",
  help_text: ""
};

const DATE_RANGE = {
  type: "date-range",
  key: "date_range789",
  label: "Date Range",
  form_display_label: "",
  prefill_current: false,
  disable: false,
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    minDays: 0,
    maxDays: 0,
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  block_past_date: false,
  mass_performance_width: 50,
  block_future_date: false,
  ai_prompt: "",
  help_text: ""
};

const MULTI_DATE = {
  type: "multi-date",
  key: "dob_879825",
  label: "Multi Date",
  form_display_label: "",
  prefill_current: false,
  disable: false,
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  block_past_date: false,
  block_future_date: false,
  mass_performance_width: 50,
  ai_prompt: "",
  help_text: ""
};

const TIME = {
  type: "time",
  key: "time_879825",
  label: "Time",
  form_display_label: "",
  prefill_current: false,
  disable: false,
  mass_performance_width: 50,
  is_24hr_format: false,
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  default_value: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  ai_prompt: "",
  help_text: ""
};

const DATETIME = {
  type: "datetime",
  key: "datetime_key",
  label: "Date-Time",
  form_display_label: "",
  prefill_current: false,
  mass_performance_width: 50,
  is_24hr_format: false,
  disable: false,
  widget: {
    type: "calendar",
    locale: "en",
    useLocaleSettings: false,
    allowInput: true,
    format: "dd-MM-yyyy hh:mm a",
    minDate: null,
    maxDate: null
  },
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  block_past_date: false,
  block_future_date: false,
  ai_prompt: "",
  help_text: ""
};

const DISABLED = {
  type: "disabled",
  key: "secret_hidden",
  label: "Disabled",
  form_display_label: "",
  mass_performance_width: 50,
  hidden: false,
  validate: {
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const CONTENT = {
  type: "content",
  key: "content_html",
  label: "Content",
  form_display_label: "",
  value: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  mass_performance_width: 50,
  ai_prompt: "",
  help_text: ""
};

const GEOLOCATION = {
  type: "geolocation",
  key: "geolocation_123456",
  label: "Geolocation",
  form_display_label: "",
  action: "auto",
  validate: {
    required: false,
    mandatory: false,
    backend_validation: false,
    regex: ""
  },
  disable: false,
  mass_performance_width: 50,
  ai_prompt: "",
  help_text: ""
};
const RATINGS = {
  type: "ratings",
  key: "ratings_123456",
  label: "Ratings",
  form_display_label: "",
  max_ratings: 2,
  validate: {
    required: false,
    mandatory: false,
    backend_validation: false,
    regex: ""
  },
  disable: false,
  mass_performance_width: 50,
  ai_prompt: "",
  help_text: ""
};
const SLIDER = {
  type: "slider",
  key: "slider_98123",
  label: "Slider",
  form_display_label: "",
  slider_step: 10,
  slider_min: 0,
  mass_performance_width: 50,
  slider_max: 100,
  validate: {
    required: false,
    backend_validation: false,
    regex: ""
  },
  default_value: 0,
  disable: false,
  help_text: ""
};
const LABEL = {
  type: "label",
  key: "label_key",
  label: "Label",
  form_display_label: "",
  // defaultAction: {
  //   action: []
  // },
  // disable: false,
  mass_performance_width: 50,
  ai_prompt: "",
  help_text: "",
  style: {
    className: {},
    inline_style: {}
  }
};
const SELECT_CHIPS = {
  type: "select-chips",
  key: "select_chips",
  label: "Select Chips",
  form_display_label: "",
  defaultValue: "",
  placeholder: "",
  sort: false,
  mass_performance_width: 50,
  search_data_api: false,
  data: {
    method: "default",
    data_key: "",
    values: []
  },
  validate: {
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  default_value: "",
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const PERCENTAGE = {
  type: "percentage",
  key: "percentage_key",
  mass_performance_width: 50,
  label: "Percentage",
  form_display_label: "",
  validate: {
    max_digit: "10",
    decimal_point: "2",
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  on_change: [],
  defaultAction: {
    action: []
  },
  default_value: "",
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const RICHTEXT = {
  type: "richtext",
  key: "richtext_key",
  label: "Richtext",
  form_display_label: "",
  mass_performance_width: 50,
  autoExpand: true,
  validate: {
    minLength: "",
    maxLength: "",
    height: "",
    required: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  default_value: "",
  on_change: [],
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const VIDEO = {
  type: "video",
  key: "video_key",
  mass_performance_width: 50,
  label: "Video",
  form_display_label: "",
  validate: {
    // minLength: "",
    // maxLength: "",
    fileMinSize: 0,
    fileMaxSize: 1,
    fileMinRange: 1,
    fileMaxRange: 1,
    duration: "",
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const AUDIO = {
  type: "audio",
  key: "audio_key",
  mass_performance_width: 50,
  label: "Audio",
  form_display_label: "",
  validate: {
    // minLength: "",
    // maxLength: "",
    fileMinSize: 0,
    fileMaxSize: 1,
    fileMinRange: 1,
    fileMaxRange: 1,
    duration: "",
    required: false,
    mandatory: false,
    // custom: []
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const SIGNATURE = {
  type: "signature",
  key: "signature_key",
  mass_performance_width: 50,
  label: "Signature",
  form_display_label: "",
  validate: {
    signature: "",
    required: false,
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const COUNTER = {
  type: "counter",
  key: "counter_key",
  mass_performance_width: 50,
  label: "Counter",
  form_display_label: "",
  validate: {
    required: false,
    custom_js: "",
    backend_validation: false,
    regex: ""
  },
  defaultAction: {
    action: []
  },
  disable: false,
  ai_prompt: "",
  help_text: ""
};

const SPACER = {
  type: "spacer",
  key: "spacer_key",
  label: "Spacer",
  form_display_label: "",
  mass_performance_width: 50,
  help_text: ""
};

const SEPARATOR = {
  label: "Separator",
  form_display_label: "",
  type: "separator",
  key: "separator_key",
  mass_performance_width: 50,
  help_text: ""
};

const JSON = {
  type: "json",
  key: "json_key",
  label: "JSON",
  form_display_label: "",
  mass_performance_width: 50,
  help_text: ""
};

const formFieldConfig = {
  textfield: TEXTFIELD,
  textarea: TEXTAREA,
  richtext: RICHTEXT,
  number: NUMBER,
  phone: PHONE,
  password: PASSWORD,
  email: EMAIL,
  checkbox: CHECKBOX,
  toggle: TOGGLE,
  file: FILE,
  url: URL,
  image: IMAGE,
  lookup: LOOKUP,
  "lookup-sm": LOOKUP_SM,
  "linked-sm-lookup": Linked_LOOKUP_SM,
  "masterdata-lookup": MASTERDATA_LOOKUP,
  "global-data": GLOBAL_DATA,
  "app-user": APP_USER,
  // "community-user": COMMUNITY_USER,
  "lookup-rdbms": LOOKUP_RDBMS,
  container: CONTAINER,
  grid: GRID,
  "rich-grid": RICH_GRID,
  recordset: RECORDSET,
  "recordset-list": RECORDSET_LIST,
  "button-group": BUTTON_GROUP,
  radio: RADIO,
  button: BUTTON,
  "id-gen": ID_GEN,
  "learning-text": LEARNING_TEXT,
  "learning-tags": LEARNING_TAGS,
  select: SELECT,
  "number-select": NUMBER_SELECT,
  selectboxes: SELECTBOXES,
  "multi-select-dropdown": MULTI_SELECT_DROPDOWN,
  currency: CURRENCY,
  date: DATE,
  "date-range": DATE_RANGE,
  "multi-date": MULTI_DATE,
  time: TIME,
  datetime: DATETIME,
  disabled: DISABLED,
  content: CONTENT,
  geolocation: GEOLOCATION,
  ratings: RATINGS,
  slider: SLIDER,
  label: LABEL,
  percentage: PERCENTAGE,
  "select-chips": SELECT_CHIPS,
  video: VIDEO,
  audio: AUDIO,
  signature: SIGNATURE,
  counter: COUNTER,
  spacer: SPACER,
  separator: SEPARATOR,
  json: JSON,
  ocr: OCR,
  "ai-doc-analyzer": AI_DOC_ANALYZER,
  "document-ocr": DocumentOCR
};
const convertFields = {
  textfield: ["textarea", "learning-text", "select", "richtext", "email", "id-gen"],
  textarea: ["textfield", "learning-text", "select", "richtext"],
  number: ["textfield", "textarea", "number-select"],
  password: [],
  email: ["textfield", "textarea"],
  checkbox: ["toggle"],
  toggle: ["checkbox"],
  file: [],
  image: ["file"],
  lookup: [],
  "lookup-sm": [],
  "global-data": [],
  "app-user": [],
  // "community-user": [],
  container: [],
  recordset: [],
  "recordset-list": [],
  "button-group": [],
  radio: ["select"],
  button: [],
  "id-gen": ["textfield", "learning-text"],
  "learning-text": ["textfield", "rictext", "textarea"],
  "learning-tags": [],
  select: ["radio", "textfield"],
  selectboxes: [],
  currency: [],
  date: ["datetime", "textfield", "time"],
  time: ["datetime", "textfield"],
  datetime: ["date", "time", "textfield"],
  disabled: [],
  content: [],
  geolocation: [],
  ratings: [],
  label: [],
  "select-chips": [],
  spacer: [],
  slider: [],
  video: [],
  audio: [],
  signature: [],
  counter: [],
  richtext: ["textarea", "learning-text", "textfield"],
  "number-select": ["textarea", "number"],
  "masterdata-lookup": ["textfield", "learning-text", "textarea"]
};

export function getFieldLabelByType(type) {
  const labelMap = {
    textfield: "Text Field",
    textarea: "Text Area",
    richtext: "Rich Text",
    number: "Number",
    phone: "Phone",
    password: "Password",
    email: "Email",
    checkbox: "Checkbox",
    toggle: "Toggle",
    file: "File Upload",
    url: "URL",
    image: "Image Upload",
    lookup: "Entity Lookup",
    "lookup-sm": "Workflow Light Lookup",
    "linked-sm-lookup": "Workflow Linked Lookup",
    "global-data": "Global Data",
    "app-user": "App User",
    // "community-user": "Community User",
    "lookup-rdbms": "RDBMS Lookup",
    container: "Container",
    grid: "Grid",
    "rich-grid": "Rich Grid",
    recordset: "Recordset",
    "recordset-list": "Recordset List",
    "button-group": "Button Group",
    radio: "Radio",
    button: "Button",
    "id-gen": "ID Generator",
    "learning-text": "Learning Text",
    "learning-tags": "Learning Tags",
    select: "Select Dropdown",
    "number-select": "Number Select",
    selectboxes: "Multi-Select Boxes",
    "multi-select-dropdown": "Multi Dropdown",
    currency: "Currency",
    date: "Date Picker",
    "multi-date": "Multiple Dates",
    time: "Time Picker",
    datetime: "DateTime Picker",
    disabled: "Disabled Field",
    content: "Static Content",
    geolocation: "Geolocation",
    ratings: "Ratings",
    slider: "Slider",
    label: "Label",
    percentage: "Percentage",
    "select-chips": "Select Chips",
    video: "Video Upload",
    audio: "Audio Upload",
    signature: "Signature Pad",
    counter: "Counter",
    spacer: "Spacer",
    separator: "Separator",
    json: "JSON Input",
    "date-range": "Date Range",
    "ai-doc-analyzer": "AI Doc Analyzer"
  };

  return labelMap[type] || type;
}

//common extra keys for all fields in subform
const extraFieldKeys = {
  read_only: false,
  unique: false,
  copy_previous_value: false,
  width: "",
  visibility_settings: {
    hide: [],
    disable: []
  }
};

//single field specific key in subform
const getFieldSpecificKeys = (fieldType) => {
  switch (fieldType) {
    case "number":
      return { show_sum: false };
    default:
      return {};
  }
};

const basicFields = [
  "textfield",
  "textarea",
  "richtext",
  "phone",
  "email",
  "number",
  "password",
  "select",
  "number-select",
  "selectboxes",
  "multi-select-dropdown",
  "checkbox",
  "radio",
  "toggle",
  "date",
  "date-range",
  "multi-date",
  "time",
  "file",
  "url",
  "image",
  "label",
  "percentage",
  "spacer",
  "separator",
  "json",
  "ocr",
  "ai-doc-analyzer",
  "document-ocr"
];
const referenceFields = [
  "lookup",
  "lookup-sm",
  "linked-sm-lookup",
  "lookup-rdbms",
  "global-data",
  "app-user",
  // "community-user",
  "masterdata-lookup"
];
const groupingFields = ["button-group", "recordset", "recordset-list", "rich-grid"];
// "container"
const moreFields = [
  "button",
  "id-gen",
  "learning-text",
  "learning-tags",
  "geolocation",
  "datetime",
  "currency",
  "disabled",
  "content",
  "ratings",
  "select-chips",
  // "video",
  // "audio",
  "signature",
  // "counter",
  "slider"
];
const allFormFields = [...basicFields, ...referenceFields, ...groupingFields, ...moreFields];

const subFormFields = [
  "textfield",
  "date",
  "date-range",
  "time",
  "number",
  "email",
  "app-user",
  "lookup",
  "lookup-sm",
  "lookup-rdbms",
  "learning-text",
  "select",
  "spacer",
  "image",
  "file",
  "percentage",
  "id-gen",
  "number-select",
  "checkbox",
  "url",
  "label",
  "separator",
  "json",
  "content",
  "ratings",
  "masterdata-lookup",
  "ocr"
];
const formFields = [];
const globalFields = ["global-data"];
const appUserFields = ["lookup-sm"];

const subFormFieldConfig = subFormFields.reduce((acc, field) => {
  const fieldType = formFieldConfig[field]?.type;
  const fieldSpecificKeys = getFieldSpecificKeys(fieldType);

  acc[field] = {
    ...formFieldConfig[field],
    ...fieldSpecificKeys,
    ...extraFieldKeys
  };

  return acc;
}, {});

function getFilterFields(type) {
  const fieldMapping = {
    appuser: { fields: appUserFields, useGlobalFields: false },
    form: { fields: formFields, useGlobalFields: false },
    sm: { fields: globalFields, useGlobalFields: false },
    subform: { fields: subFormFields, useGlobalFields: true }
  };

  return fieldMapping[type] || { fields: [], useGlobalFields: false };
}

function filterFormFields(type) {
  const { fields, useGlobalFields } = getFilterFields(type);
  if (useGlobalFields) {
    return {
      basicFields: basicFields.filter((field) => fields.includes(field)),
      referenceFields: referenceFields.filter((field) => fields.includes(field)),
      groupingFields: groupingFields.filter((field) => fields.includes(field)),
      moreFields: moreFields.filter((field) => fields.includes(field))
    };
  } else {
    return {
      basicFields: basicFields.filter((field) => !fields.includes(field)),
      referenceFields: referenceFields.filter((field) => !fields.includes(field)),
      groupingFields: groupingFields.filter((field) => !fields.includes(field)),
      moreFields: moreFields.filter((field) => !fields.includes(field))
    };
  }
}

export { allFormFields, basicFields, convertFields, filterFormFields, formFieldConfig, subFormFieldConfig };

const KEY_LABELS = {
  type: "Type",
  key: "Key",
  label: "Label",
  validate: "Validation",
  startWith: "Starts With",
  endWith: "Ends With",
  minLength: "Min Length",
  maxLength: "Max Length",
  minValue: "Min Value",
  maxValue: "Max Value",
  length: "Length",
  required: "Required",
  mandatory: "Mandatory",
  custom_js: "Custom JS",
  backend_validation: "Backend Validation",
  on_change: "On Change",
  defaultAction: "Default Action",
  disable: "Disabled",
  ai_prompt: "AI Prompt",
  help_text: "Help Text",
  multiple: "Allow Multiple Options",
  storage: "Storage",
  filePattern: "File Pattern",
  show_cabinet: "Allow from Cabinet",
  fileMinSize: "File Min Size",
  fileMaxSize: "File Max Size",
  fileMinRange: "File Min Range",
  fileMaxRange: "File Max Range",
  upload_on_select: "Upload On Select",
  autoExpand: "Auto Expand",
  default_country_code: "Default Country Code",
  passwordPattern: "Password Pattern",
  emailPattern: "Restricted domain",
  title: "Title",
  components: "Components",
  table_id: "Select Statemachine",
  allow_add_entity: "Allow Add Entity",
  allow_edit_entity: "Allow Edit Entity",
  show_default_option: "Show Option by default",
  prefill_filtered_data: "Prefill Filtered Data",
  exclude_duplicate: "Exclude Duplicate",
  display_fields: "Display Fields While Searching",
  access_fields: "Copy fields (To be accessed in SM)",
  pre_filters: "Pre Filters",
  prefilters_joined_by: "Prefilters Joined By",
  field_filters: "Field Filters",
  field_filters_joined_by: "Field Filters Joined By",
  lookup_query: "Lookup Query",
  filter_varmap: "Filter Varmap",
  data_varmap: "Data Varmap",
  primary_key: "Primary Key",
  card_design: "Card Design",
  global_field: "Global Field",
  app_user_filter: "App User Filter",
  groups: "Groups",
  designations: "Designations",
  sub_fields: "Sub Fields while searching",
  allow_add_sm: "Allow Add Statemachine",
  is_card_format: "Card Format",
  import_cart: "Cart",
  sub_form: "Sub Form",
  cart_mapping: "Cart Mapping",
  master_data: "Master Data",
  prefill_current_user: "Prefill Current User",
  show_app_user_team_only: "Show App User Team Only",
  action: "Action",
  allow_new: "Allow adding new",
  block: "Block",
  block_future_date: "Block Future Date",
  block_past_date: "Block Past Date",
  confirmation_box: "Ask Confirmation",
  currency: "Currency",
  data: "Data",
  data_key: "Data Key",
  date_format: "Date Format",
  decimal_point: "Decimal Point",
  defaultValue: "Default Value",
  desktop: "Desktop",
  disableOnInvalid: "Disable On Invalid",
  id_gen_config: "ID Gen Config",
  inline: "Inline",
  isHorizontal: "Is Horizontal",
  is_24hr_format: "Is 24hr Format",
  leftIcon: "Left Icon",
  mass_performance_width: "Mass Performance Width",
  max_digit: "Max Digit",
  method: "Method",
  mobile: "Mobile",
  placeholder: "Placeholder",
  prefill_current: "Prefill Current Date",
  prefix: "ID Prefix",
  reset_type: "Reset Type",
  search_data_api: "Search Data API",
  sequence: "Generate in sequence",
  show_chips_format: "Show Chips Format",
  sort: "Sorted Options",
  values: "Values",
  slider_step: "Slider Step",
  slider_min: "Slider Min",
  slider_max: "Slider Max",
  duration: "Duration",
  signature: "Signature",
  style: "Style",
  className: "Class Name",
  inline_style: "Inline Style",
  heigth: "Minimum Height",
  from_camera: "Upload From Camera",
  max_ratings: "Number of Stars",
  rdbms_to_form_map: "Rdbms to Form Maping",
  is_searchable: "Is Searchable",
  min_selections: "Minimum Selections",
  max_selections: "Maximum Selections",
  filePrefix: "File Prefix",
  hide_info_fields: "Hide Info Fields",
  form_display_label: "Display Label",
  custom_width_px: "Custom Width (px)"
};

function toReadableLabel(key) {
  return key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getLabelForKey(key) {
  return KEY_LABELS[key] || toReadableLabel(key);
}
